import { getApplicationIntake } from "./application-intake.ts";

export const loadApplicationIntake = ({
    params,
}: {
    params: { token: string };
}) => getApplicationIntake({ data: params.token });
